import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "./components/layout/DashboardLayout";
import Overview from "./pages/Overview";
import Blogs from "./pages/Blogs";
import BlogCategories from "./pages/BlogCategories";
import Settings from "./pages/Settings";
import ContactSubmissions from "./pages/ContactSubmissions";
import EstimateRequests from "./pages/EstimateRequests";
import FAQManager from "./pages/FAQManager";
import TestimonialsManager from "./pages/TestimonialsManager";
import Login from "./pages/Login";
import SeoManager from "./pages/SeoManager";
import AddImage from "./pages/AddImage";
import GalleryManager from "./pages/GalleryManager";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<Overview />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogcategories" element={<BlogCategories />} />
          <Route path="/gallery_manager" element={<GalleryManager />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/messages" element={<ContactSubmissions />} />
          <Route path="/estimates" element={<EstimateRequests />} />
          <Route path="/faqs" element={<FAQManager />} />
          <Route path="/testimonials" element={<TestimonialsManager />} />
          <Route path="/seo" element={<SeoManager />} />
          <Route path="/images" element={<AddImage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
